import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, Store, ChevronDown, LayoutDashboard, LogOut } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import NotificationBell from '../NotificationBell';

const HeaderActions = ({ session, onLogout, onPostRequirement, t }) => {
  const navigate = useNavigate();

  return (
    <div className="hidden lg:flex items-center gap-2 ml-2 order-4">
      {session?.role !== 'vendor' && (
        <Link to="/vendor/register">
          <Button variant="outline" className="border-[#2c54b2] text-[#2c54b2] hover:bg-[#2c54b2] hover:text-white font-medium dark:border-orange-400 dark:text-orange-400">
            <Store className="w-4 h-4 mr-1" /> {t('cta.become_vendor')}
          </Button>
        </Link>
      )}
      <Button
        onClick={onPostRequirement}
        className="bg-[#2c54b2] hover:bg-[#1f3f87] text-white font-medium"
      >
        {t('cta.post_requirement')}
      </Button>
      {session && (
        <NotificationBell role={session.role === 'vendor' ? 'vendor' : 'customer'} tone="dark" />
      )}
      {session ? (
        <DropdownMenu>
          <DropdownMenuTrigger
            className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full text-sm font-medium text-gray-700 dark:text-gray-200 transition-colors inline-flex items-center gap-1.5"
            data-testid="header-session-menu"
          >
            <User className="w-4 h-4" />
            <span className="max-w-[120px] truncate">{session.name}</span>
            <ChevronDown className="w-3.5 h-3.5" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <div className="px-2 py-1.5 text-xs text-gray-500">
              Logged in as <b className="text-gray-800 dark:text-gray-200">{session.role}</b>
            </div>
            {session.role === 'vendor' ? (
              <DropdownMenuItem onClick={() => navigate('/vendor/dashboard')} data-testid="header-go-vendor-dashboard">
                <LayoutDashboard className="w-4 h-4 mr-2" /> Vendor Dashboard
              </DropdownMenuItem>
            ) : (
              <DropdownMenuItem onClick={() => navigate('/account')}>
                <User className="w-4 h-4 mr-2" /> My Account
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onClick={onLogout} data-testid="header-logout">
              <LogOut className="w-4 h-4 mr-2 text-red-600" /> <span className="text-red-600">Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <>
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:text-[#ee5e23] dark:hover:text-orange-400 transition-colors border-l border-gray-200 dark:border-gray-700 ml-1 pl-3 whitespace-nowrap"
            data-testid="header-login"
            title="Login"
          >
            <User className="w-4 h-4" /> Login
          </Link>
          <Link
            to="/register"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold text-white bg-[#2c54b2] hover:bg-[#1f3f87] rounded-md whitespace-nowrap"
            data-testid="header-register"
            title="Register"
          >
            Register
          </Link>
        </>
      )}
    </div>
  );
};

export default HeaderActions;
